import helpers from "../helpers";

let $illustrationPositioning = null;
let $linesBottom = null;
let $linesBottomAnimated = null;
let $screenWords = null;
let $screenWordsBlink = null;
let $light = null;
let $platformLines = null;
let $platformLinesAnimated = null;
let $man1 = null;
let $man2 = null;
let $man3 = null;
let $car = null;
let $elementFill = null;
let $elementStroke = null;
let $placemark1 = null;
let $placemark2 = null;
let $placemark3 = null;
let $placemark4 = null;
let $placemark = null;
let $placemarkAnimated = null;
let $craneHook = null;
let $craneHookImage = null;
let $craneCabin = null;
let $craneSlider = null;

const duration = 0.45;
const screenWordsColor = '#5b99f4';
const screenWordsColorAnimated = '#e29a86';
const elementStrokeColor = '#acf';
const elementStrokeColorAnimated = '#d69f72';

let animation = null;

const getPercentPosition = ($element, x, y) => {
	return {
		x: x / $element.clientWidth * 100,
		y: y / $element.clientHeight * 100,
	};
};

const pause = () => {
	if (animation && !animation.paused()) {
		animation.pause();
	}
};

const play = () => {
	if (animation && animation.paused()) {
		animation.play();
	}
};

const create = () => {
	if (animation || !$illustrationPositioning) {
		return;
	}

	animation = gsap
		.timeline({
			delay: 1,
			paused: true,
		})
		.to($linesBottom, {
			duration,
			opacity: 0,
		}, 2)
		.to($linesBottomAnimated, {
			duration,
			opacity: 1,
		}, 2)
		.to($screenWords, {
			duration: 0.15,
			stagger: 0.025,
			opacity: 1,
			xPercent: 0,
		}, 0.5)
		.to($light, {
			duration: duration * 2,
			opacity: 1,
		}, 0)
		.to($platformLinesAnimated, {
			duration: duration * 3,
			strokeDashoffset: 0,
		}, 2)
		.to($elementFill, {
			duration,
			stagger: duration / 2,
			opacity: 0.5,
		}, 3.25)
		.to($elementStroke, {
			duration,
			opacity: 1,
		}, 1.5)
		.to($elementStroke, {
			duration,
			stagger: duration / 2,
			stroke: elementStrokeColorAnimated,
		}, 2.5)
		.to([$placemark1, $placemark2, $placemark3, $placemark4], {
			duration,
			stagger: 0.1,
			opacity: 1,
			yPercent: 0,
		}, 1.5)
		.to($placemark, {
			duration,
			stagger: duration / 2,
			opacity: 0,
		}, 2.5)
		.to($placemarkAnimated, {
			duration,
			stagger: duration / 2,
			opacity: 1,
		}, 2.5);

	$screenWordsBlink.forEach(($screenWordsBlinkCurrent, index) => {
		animation.to($screenWordsBlinkCurrent, {
			delay: 'random(0.25, 0.75)',
			duration: 'random(0.1, 0.3)',
			repeat: -1,
			repeatDelay: 0.03 + index / 2 * 0.03,
			repeatRefresh: true,
			yoyo: true,
			fill: screenWordsColorAnimated,
		}, 2.5);
	});

	[$car, $placemark4, $craneHook, $craneCabin, $craneSlider].forEach(($element) => {
		let positionMove = null;
		let durationMove = 2;
		let delay = 4;
		let repeatDelay = 1;

		if ($element === $car || $element === $placemark4) {
			positionMove = getPercentPosition($element, 42, 18);

			if(helpers.isMobile()) {
				positionMove = getPercentPosition($car, 30, 10);
			}
		} else if ($element === $craneCabin) {
			positionMove = getPercentPosition($element, 34, 14);
			delay = 2.5;
			repeatDelay = 1.5;
		} else {
			positionMove = getPercentPosition($element, 90, 37);
			durationMove = 3;
			delay = 3;
			repeatDelay = 1;
		}

		animation.to($element, {
			duration: durationMove,
			ease: 'none',
			repeat: -1,
			repeatDelay,
			yoyo: true,
			xPercent: positionMove.x,
			yPercent: positionMove.y,
		}, delay);

		if ($element === $craneHook) {
			if(helpers.isMobile()) {
				positionMove = getPercentPosition($craneHook, 60, 24);

				animation.to($craneHook, {
					duration: durationMove,
					ease: 'none',
					repeat: -1,
					repeatDelay,
					yoyo: true,
					xPercent: positionMove.x,
					yPercent: positionMove.y,
				}, delay);
			}

			animation
				.to($craneHookImage, {
					duration: repeatDelay / 2,
					ease: 'none',
					repeat: -1,
					repeatDelay: durationMove * 2 + delay,
					yPercent: 30,
				}, delay + durationMove)
				.to($craneHookImage, {
					duration: repeatDelay / 2,
					ease: 'none',
					repeat: -1,
					repeatDelay: durationMove * 2 + delay,
					yPercent: 0,
				}, delay + durationMove + repeatDelay / 2);
		}

		if(helpers.isMobile() && $element === $craneSlider) {
			positionMove = getPercentPosition($craneSlider, 60, 24);

			console.log('true')

			animation.to($craneSlider, {
				duration: durationMove,
				ease: 'none',
				repeat: -1,
				repeatDelay,
				yoyo: true,
				xPercent: positionMove.x,
				yPercent: positionMove.y,
			}, delay);
		}
	});
};

const reset = () => {
	$illustrationPositioning = document.querySelector('.illustration-positioning');
	$linesBottom = document.querySelector('.illustration-positioning__element--lines-bottom img:first-child');
	$linesBottomAnimated = document.querySelector('.illustration-positioning__element--lines-bottom img:last-child');
	$screenWords = document.querySelectorAll('.illustration-positioning__element--screen .screen-word');
	$screenWordsBlink = document.querySelectorAll('.illustration-positioning__element--screen .screen-word-blink');
	$light = document.querySelector('.illustration-positioning__element--light');
	$platformLines = document.querySelector('.illustration-positioning__element--platform-lines .platform-lines');
	$platformLinesAnimated = document.querySelector('.illustration-positioning__element--platform-lines .platform-lines-animated');
	$man1 = document.querySelector('.illustration-positioning__element--man-1');
	$man2 = document.querySelector('.illustration-positioning__element--man-2');
	$man3 = document.querySelector('.illustration-positioning__element--man-3');
	$car = document.querySelector('.illustration-positioning__element--car');
	$elementFill = document.querySelectorAll('.illustration-positioning .element-fill');
	$elementStroke = document.querySelectorAll('.illustration-positioning .element-stroke');
	$placemark1 = document.querySelector('.illustration-positioning__element--placemark-1');
	$placemark2 = document.querySelector('.illustration-positioning__element--placemark-2');
	$placemark3 = document.querySelector('.illustration-positioning__element--placemark-3');
	$placemark4 = document.querySelector('.illustration-positioning__element--placemark-4');
	$placemark = document.querySelectorAll('[class*="element--placemark"] svg:first-child');
	$placemarkAnimated = document.querySelectorAll('[class*="element--placemark"] svg:last-child');
	$craneHook = document.querySelector('.illustration-positioning__element--crane-hook');
	$craneHookImage = document.querySelector('.illustration-positioning__element--crane-hook img');
	$craneCabin = document.querySelector('.illustration-positioning__element--crane-cabin');
	$craneSlider = document.querySelector('.illustration-positioning__element--crane-slider');

	const gsapElements = [
		$linesBottom,
		$linesBottomAnimated,
		$screenWords,
		$screenWordsBlink,
		$light,
		$platformLines,
		$platformLinesAnimated,
		$man1,
		$man2,
		$man3,
		$car,
		$elementFill,
		$elementStroke,
		$placemark1,
		$placemark2,
		$placemark3,
		$placemark4,
		$placemark,
		$placemarkAnimated,
		$craneHook,
		$craneHookImage,
		$craneCabin,
		$craneSlider,
	];

	gsap.killTweensOf(gsapElements);

	gsap
		.timeline()
		.set([
			$linesBottomAnimated,
			$screenWords,
			$light,
			$elementFill,
			$elementStroke,
			$placemark1,
			$placemark2,
			$placemark3,
			$placemark4,
		], {opacity: 0})
		.set($screenWords, {xPercent: -5})
		.set($screenWordsBlink, {fill: screenWordsColor})
		.set($platformLinesAnimated, {
			strokeDasharray: 550,
			strokeDashoffset: 550,
		})
		.set($elementStroke, {stroke: elementStrokeColor})
		.set([$placemark1, $placemark2, $placemark3, $placemark4], {yPercent: -50})
		.set($placemarkAnimated, {opacity: 0});

	if (animation) {
		animation.kill();

		animation = null;
	}
};

const init = () => {
	reset();
	create();
};

export default {
	init,
	reset,
	create,
	play,
	pause,
};
